import ExternalBlog from './externalBlog';
export { IBlogPreviewContent } from './interfaces';

export default ExternalBlog;


// WEBPACK FOOTER //
// ../helpers/src/externalBlog/index.ts